var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "tableContainer",
    staticClass: "table-responsive  downline-rep-list-table"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', [_vm.isInitialLoad ? _c('tr', [_c('td', {
    staticClass: "empty-state-cell",
    attrs: {
      "colspan": "7"
    }
  }, [_c('div', {
    staticClass: "quick-date-btns-inline d-flex align-items-center justify-content-center gap-2 flex-wrap mb-3"
  }, [_c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'all'
    },
    attrs: {
      "type": "button",
      "title": "All reps"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'all');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-list me-1"
  }), _vm._v(" All Reps ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'today'
    },
    attrs: {
      "type": "button",
      "title": "Reps signed up today"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'today');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-day me-1"
  }), _vm._v(" Reps Today ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'week'
    },
    attrs: {
      "type": "button",
      "title": "Reps signed up this week"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'week');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-week me-1"
  }), _vm._v(" Reps This Week ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'month'
    },
    attrs: {
      "type": "button",
      "title": "Reps signed up this month"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'month');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt me-1"
  }), _vm._v(" Reps This Month ")])]), _vm._m(1)])]) : !_vm.rows.records ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No records found.")])]) : _vm._l(_vm.rows.records, function (row, index) {
    var _row$upline_details, _row$upline_details2;

    return _c('tr', {
      key: index,
      class: "row-status-".concat(row.agent_status.toLowerCase())
    }, [_c('td', [_c('span', [_vm._v(" Signup Date: "), _c('strong', [_vm._v(_vm._s(row.agent_signup_date))])]), _c('span', {
      class: "id-status-".concat(row.agent_status.toLowerCase())
    }, [_vm._v(" " + _vm._s(row.agent_status) + " ")]), _c('span', [_vm._v(" Level: "), _c('b', [_vm._v(_vm._s(row.agent_level))])]), _c('div', [_vm._v(" Premier Level: "), _c('strong', [_vm._v(" " + _vm._s(row.agent_level === null || row.agent_level === 0 ? "N/A" : row.agent_level) + " ")]), _c('br'), _vm._v(" Smart Level: "), _c('strong', [_vm._v(" " + _vm._s(row.agent_level_2 === null || row.agent_level_2 === 0 ? "N/A" : row.agent_level_2) + " ")]), Array.isArray(row.contracts) && row.contracts.length >= 1 ? [_vm._l(row.contracts.slice(0, 2), function (signedContract, index) {
      return _c('div', {
        key: index
      }, [signedContract.data && Array.isArray(signedContract.data) ? _vm._l(signedContract.data.slice(0, 2), function (signedCont, ind) {
        return _c('div', {
          key: ind
        }, [_vm._v(" " + _vm._s(signedCont.contract_item_display_name) + " Level: "), _c('strong', [_vm._v(_vm._s(signedCont.contract_level))])]);
      }) : _vm._e()], 2);
    }), row.contracts.some(function (contract) {
      return contract.data && contract.data.length > 2;
    }) ? _c('a', {
      staticClass: "signed-contract-details",
      on: {
        "click": function click($event) {
          return _vm.openSignedContractModal(row.contracts);
        }
      }
    }, [_vm._v(" Show More ")]) : _vm._e()] : _vm._e()], 2)]), _c('td', [row.business && _vm.getBusinessName(row.business) ? _c('div', {
      staticClass: "company-name"
    }, [_c('strong', [_vm._v("Business Name:")]), _c('div', [_vm._v(_vm._s(_vm.getBusinessName(row.business)))])]) : _vm._e(), _c('div', {
      staticClass: "rep-name"
    }, [_c('strong', [_vm._v("Agent Name:")]), _vm._v(" " + _vm._s(row.agent_fname) + " " + _vm._s(row.agent_lname) + " ")]), row.agent_code ? _c('div', {
      staticClass: "rep-code"
    }, [_c('strong', [_vm._v("(" + _vm._s(row.agent_code) + ") ")])]) : _vm._e(), row.groups && row.groups.length ? _c('div', {
      staticClass: "rep-groups"
    }, [_c('strong', [_vm._v("Groups:")]), _vm._l(row.groups, function (g, index) {
      return _c('span', {
        key: index
      }, [_vm._v(" " + _vm._s(g)), index !== row.groups.length - 1 ? [_vm._v(", ")] : _vm._e()], 2);
    })], 2) : _vm._e()]), row.upline_details ? _c('td', [_c('span', [_vm._v(" " + _vm._s(row.upline_details.upline_first_name) + " " + _vm._s(row.upline_details.upline_last_name) + " ")]), _c('span', [_vm._v(_vm._s((_row$upline_details = row.upline_details) === null || _row$upline_details === void 0 ? void 0 : _row$upline_details.upline_agent_code))]), _c('span', [_c('strong', [_vm._v("Level:")]), _vm._v(" " + _vm._s((_row$upline_details2 = row.upline_details) === null || _row$upline_details2 === void 0 ? void 0 : _row$upline_details2.upline_agent_level) + " ")])]) : _c('td', [_vm._v("Upline agent not found")]), _c('td', [_c('span', [_c('strong', [_vm._v("Location:")]), _vm._v(" " + _vm._s(row.agent_city) + "," + _vm._s(row.agent_state) + " ")]), _c('span', [_c('strong', [_vm._v("Phone 1:")]), _vm._v(" " + _vm._s(row.agent_phone1) + " "), row.agent_phone1 ? _c('valid-icon', {
      attrs: {
        "is-valid": row.is_phone1_valid,
        "className": "valid-icon"
      }
    }) : _vm._e()], 1), row.agent_phone2 ? _c('span', [_c('strong', [_vm._v("Phone 2:")]), _vm._v(" " + _vm._s(row.agent_phone2) + " "), row.agent_phone2 ? _c('valid-icon', {
      attrs: {
        "is-valid": row.is_phone2_valid,
        "className": "valid-icon"
      }
    }) : _vm._e()], 1) : _vm._e(), _c('span', [_c('strong', [_vm._v("Email / Username:")]), _c('br'), _vm._v(" " + _vm._s(row.agent_email) + " "), _c('valid-icon', {
      attrs: {
        "is-valid": row.is_email_valid,
        "className": "valid-icon"
      }
    })], 1), row.agent_profile_link ? _c('span', {
      staticClass: "info-link"
    }, [_vm._v(" " + _vm._s(row.agent_profile_link.title ? "".concat(row.agent_profile_link.title, ":") : "") + " " + _vm._s(row.agent_profile_link.link) + " ")]) : _vm._e()]), _c('td', [_c('ul', [_c('li', [_c('strong', [_vm._v("A:")]), _vm._v(" " + _vm._s(row.agent_active_total) + " ")]), _c('li', [_c('strong', [_vm._v("W:")]), _vm._v(" " + _vm._s(row.agent_withdraw_total) + " ")]), _c('li', [_c('strong', [_vm._v("T:")]), _vm._v(" " + _vm._s(row.agent_termed_total) + " ")]), _c('li', [_c('strong', [_vm._v("Totals:")]), _vm._v(" " + _vm._s(_vm.getStatTotal(row.agent_active_total, row.agent_withdraw_total, row.agent_termed_total)) + " ")])]), _vm.getStatTotal(row.agent_active_total, row.agent_withdraw_total, row.agent_termed_total) > 0 ? [_c('router-link', {
      staticClass: "viewClient-btn",
      attrs: {
        "to": {
          name: 'MemberListByRep',
          params: {
            repId: _vm.encodedId(row.agent_id),
            type: 'direct'
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(" View Clients ")])] : _vm._e()], 2), _c('td', [_c('ul', [_c('li', [_c('strong', [_vm._v("A:")]), _vm._v(" " + _vm._s(row.agent_active_downline_policy) + " ")]), _c('li', [_c('strong', [_vm._v("W:")]), _vm._v(" " + _vm._s(row.agent_withdrawn_downline_policy) + " ")]), _c('li', [_c('strong', [_vm._v("T:")]), _vm._v(" " + _vm._s(row.agent_termed_downline_policy) + " ")]), _c('li', [_c('strong', [_vm._v("Totals:")]), _vm._v(" " + _vm._s(_vm.getStatTotal(row.agent_active_downline_policy, row.agent_withdrawn_downline_policy, row.agent_termed_downline_policy)) + " ")])]), _vm.getStatTotal(row.agent_active_downline_policy, row.agent_withdrawn_downline_policy, row.agent_termed_downline_policy) > 0 ? [_c('router-link', {
      staticClass: "viewClient-btn",
      attrs: {
        "to": {
          name: 'MemberListByRep',
          params: {
            repId: _vm.encodedId(row.agent_id),
            type: 'downline'
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(" View Clients ")])] : _vm._e()], 2), row.agent_status.toLowerCase() !== 'deleted' ? _c('td', [_c('div', {
      staticClass: "action-btns"
    }, [_c('custom-route-button', {
      attrs: {
        "title": "View/Edit Details",
        "iconClass": "fas fa-info",
        "routeLink": {
          name: 'DownlineRepDetail',
          params: {
            downlineRepId: _vm.encodedId(row.agent_id)
          }
        }
      }
    }), row.actions.show_disable_agent == 1 ? [row.actions.disable_agent == 1 ? [_c('custom-button', {
      attrs: {
        "title": "Disable Agent",
        "iconClass": "fas fa-minus"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.enableDisableAgent(row.agent_id, 0);
        }
      }
    })] : _vm._e()] : _vm._e(), row.actions.show_elite_blue == 1 && row.actions.enable_elite_blue == 0 ? void 0 : _vm._e(), row.actions.send_email_to_rep ? [_c('custom-button', {
      attrs: {
        "title": "Send Email",
        "iconClass": "fas fa-envelope"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.openSendEmailModal(row);
        }
      }
    })] : _vm._e(), _c('custom-button', {
      attrs: {
        "title": "Send Upload File Link",
        "iconClass": "fas fa-link"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.openSendFileUploadModal(row);
        }
      }
    }), row.actions.send_rep_login_info ? _c('custom-button', {
      attrs: {
        "title": "Send Reg/Login Email",
        "iconClass": "fas fa-lock"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'downlineSendLoginEmail');
        }
      }
    }) : _vm._e(), row.actions.send_rep_login_info ? [_c('custom-button', {
      attrs: {
        "title": "Send Information",
        "iconClass": "far fa-paper-plane"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.openSendInfoModal(row);
        }
      }
    })] : _vm._e(), _vm.rows.is_assign_contract && !_vm.isEnrollPrime ? [_c('custom-button', {
      attrs: {
        "title": "Send Contracts",
        "iconClass": "far fa-file"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.openSendContractModal(row);
        }
      }
    })] : _vm._e(), row.show_contract ? [_c('custom-button', {
      attrs: {
        "title": "View Contract Pdf",
        "iconClass": "far fa-eye"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.openViewContractPdfModal(row);
        }
      }
    })] : _vm._e(), _c('custom-route-button', {
      attrs: {
        "title": "Assign Plan",
        "iconClass": "fas fa-plus",
        "routeLink": {
          name: 'DownlineRepPlans',
          params: {
            downlineRepId: _vm.encodedId(row.agent_id)
          }
        }
      }
    }), !_vm.isEnrollPrime ? _c('custom-button', {
      attrs: {
        "title": "Benefit Store",
        "iconClass": "fas fa-shopping-cart"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.agentBenefitStoreLink(row.agent_id);
        }
      }
    }) : _vm._e(), row.downline_details_count ? _c('custom-route-button', {
      attrs: {
        "title": "View Rep Tree",
        "iconClass": "fas fa-sitemap",
        "routeLink": {
          name: 'DownlineTree',
          params: {
            agent_id: _vm.encodedId(row.agent_id)
          }
        }
      }
    }) : _vm._e(), row.actions.show_default_otp ? _c('custom-button', {
      attrs: {
        "title": "View Default OTP",
        "iconClass": "fas fa-list"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'defaultOtpModal');
        }
      }
    }) : _vm._e(), !_vm.isEnrollPrime ? _c('custom-route-button', {
      attrs: {
        "title": "View License",
        "iconClass": "fas fa-id-card",
        "routeLink": {
          name: 'Licenses',
          params: {
            downlineRepId: _vm.encodedId(row.agent_id)
          }
        }
      }
    }) : _vm._e(), !_vm.isEnrollPrime ? _c('custom-button', {
      attrs: {
        "title": "Add License",
        "iconClass": "fas fa-plus-circle"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.openAddLicenseModal(row);
        }
      }
    }) : _vm._e(), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        value: _vm.ViewMsg,
        expression: "ViewMsg",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "custom-btn",
      attrs: {
        "title": "View msg"
      },
      on: {
        "click": function click($event) {
          return _vm.routeToViewMessage(row);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/images/view-msg.svg")
      }
    })]), row.actions.is_deletable ? _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        value: 'Soft Delete Agent',
        expression: "'Soft Delete Agent'",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "custom-btn",
      attrs: {
        "title": "Delete Agent"
      },
      on: {
        "click": function click($event) {
          return _vm.checkUpLineAgent(row.agent_id);
        }
      }
    }, [_c('img', {
      staticClass: "delete-agent-btn",
      attrs: {
        "src": require("../../../assets/images/downline-delete.svg")
      }
    })]) : _vm._e(), !_vm.isEnrollPrime ? _c('custom-button', {
      attrs: {
        "title": "Restrict Platforms",
        "iconClass": "fa fa-server"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'restrict-platform-modal');
        }
      }
    }) : _vm._e(), _vm.isVipUser && row.agent_status == 'Approved' ? _c('custom-button', {
      attrs: {
        "title": "Switch Account",
        "iconClass": "fas fa-exchange-alt"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.switchRep(row);
        }
      }
    }) : _vm._e(), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": "javascript:void(0);",
        "title": "Add Notes"
      },
      on: {
        "click": function click($event) {
          return _vm.openAddNotesModal(row);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/add-notes-rounded.svg"),
        "width": "16px",
        "alt": "Add Agent Notes"
      }
    })]), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": "javascript:void(0);",
        "title": "View Notes"
      },
      on: {
        "click": function click($event) {
          return _vm.openViewNotesModal(row);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/notes-bold.svg"),
        "width": "16px",
        "alt": "View Agent Notes"
      }
    })])], 2)]) : _vm._e(), row.agent_status.toLowerCase() == 'deleted' && row.actions.is_activatable ? _c('td', [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        value: 'Restore Agent',
        expression: "'Restore Agent'",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "custom-btn",
      attrs: {
        "title": "reactive Agent"
      },
      on: {
        "click": function click($event) {
          return _vm.restoreAgent(row.agent_id);
        }
      }
    }, [_c('img', {
      staticClass: "delete-agent-btn",
      attrs: {
        "src": require("../../../assets/images/reactivate.svg")
      }
    })])]) : _vm._e()]);
  })], 2)]), _c('downline-rep-send-email', {
    attrs: {
      "agent": _vm.selectedAgent
    },
    on: {
      "onClosedModal": _vm.onAgentModalClosed
    }
  }), _c('downline-rep-send-info', {
    attrs: {
      "agent": _vm.selectedAgent
    },
    on: {
      "onClosedModal": _vm.onAgentModalClosed
    }
  }), _c('send-representative-contract-modal', {
    attrs: {
      "agent": _vm.selectedAgent
    },
    on: {
      "onClosedModal": _vm.sendContract
    }
  }), _c('view-contract-pdf-modal', {
    attrs: {
      "agent": _vm.selectedAgent
    },
    on: {
      "onClosedModal": _vm.viewContractPdfModal
    }
  }), _c('assign-level-modal', {
    attrs: {
      "agent": _vm.selectedAgent
    },
    on: {
      "onClosedModal": _vm.assignLevel
    }
  }), _c('downline-rep-send-login-email', {
    attrs: {
      "agent": _vm.selectedAgent
    },
    on: {
      "onClosedModal": _vm.onAgentModalClosed
    }
  }), _c('default-otp-modal', {
    attrs: {
      "row": _vm.selectedAgent,
      "rowType": "A"
    },
    on: {
      "update:row": function updateRow($event) {
        _vm.selectedAgent = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.selectedAgent = null;
      }
    }
  }), _c('downline-list-modal', {
    attrs: {
      "agentDownlineInfo": _vm.agentDownlineInfo
    },
    on: {
      "getUserList": _vm.getUserList
    }
  }), _c('signed-contract-modal', {
    attrs: {
      "signedContractData": _vm.signedContract
    }
  }), _c('restrict-platform-modal', {
    attrs: {
      "row": _vm.selectedAgent
    }
  }), _c('add-notes-modal', {
    attrs: {
      "row": _vm.agentNote,
      "isOpen": _vm.showAddNotesModal
    },
    on: {
      "close": function close($event) {
        _vm.showAddNotesModal = false;
      }
    }
  }), _c('view-notes-modal', {
    attrs: {
      "row": _vm.agentNote,
      "isOpen": _vm.showViewNotesModal
    },
    on: {
      "close": function close($event) {
        _vm.showViewNotesModal = false;
      }
    }
  }), _c('add-license-modal', {
    attrs: {
      "agent": _vm.selectedAgent
    },
    on: {
      "onSuccess": _vm.onAgentModalClosed
    }
  }), _c('downline-file-upload-access', {
    attrs: {
      "userType": "REP"
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _c('th', [_vm._v("Name(Code) & Group(s)")]), _c('th', [_vm._v("Upline")]), _c('th', [_vm._v("Contact Info")]), _c('th', [_vm._v("Direct Totals")]), _c('th', [_vm._v("Downline Totals")]), _c('th', [_vm._v("Actions")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "empty-state-msg"
  }, [_c('i', {
    staticClass: "fas fa-search me-2"
  }), _vm._v(" Enter search criteria or use a quick search above to display results. ")]);
}]

export { render, staticRenderFns }